(function () {
  function updateCardByVariantInput(input) {
    if (!input) return;

    const card = input.closest('[data-card-product]');
    if (!card) return;

    const variantId = input.dataset.variantId;
    if (!variantId) return;

    const productId = card.dataset.productId;
    if (!productId) return;

    const sectionId =
      card.closest('[data-id]')?.dataset.id ||
      card.closest('[id^="collection-"]')?.id?.replace('collection-', '') ||
      '';

    if (!sectionId) return;

    const mapName =
      'variantDataMap' +
      String(sectionId).replace(/-/g, '_') +
      '_' +
      String(productId).replace(/-/g, '_');

    const variantMap = window[mapName];
    if (!variantMap || !variantMap[variantId]) return;

    const variantData = variantMap[variantId];
    const mainImage = card.querySelector('[data-card-main-image]');
    const secondaryImage = card.querySelector('[data-card-secondary-image]');
    const links = card.querySelectorAll('.card-product-main-link');

    if (mainImage && variantData.imageUrl) {
      mainImage.src = variantData.imageUrl;
      mainImage.setAttribute('srcset', variantData.imageUrl);
    }

    if (secondaryImage) {
      if (variantData.secondaryImageUrl) {
        secondaryImage.src = variantData.secondaryImageUrl;
        secondaryImage.setAttribute('srcset', variantData.secondaryImageUrl);
      } else if (variantData.imageUrl) {
        secondaryImage.src = variantData.imageUrl;
        secondaryImage.setAttribute('srcset', variantData.imageUrl);
      }
    }

    if (variantData.productUrl && links.length) {
      links.forEach((link) => {
        link.setAttribute('href', variantData.productUrl);
      });
    }
  }

  function previewHoverImage(label) {
    if (!label) return;

    const card = label.closest('[data-card-product]');
    if (!card) return;

    const inputId = label.getAttribute('for');
    if (!inputId) return;

    const input = document.getElementById(inputId);
    if (!input) return;

    const variantId = input.dataset.variantId;
    if (!variantId) return;

    const productId = card.dataset.productId;
    if (!productId) return;

    const sectionId =
      card.closest('[data-id]')?.dataset.id ||
      card.closest('[id^="collection-"]')?.id?.replace('collection-', '') ||
      '';

    if (!sectionId) return;

    const mapName =
      'variantDataMap' +
      String(sectionId).replace(/-/g, '_') +
      '_' +
      String(productId).replace(/-/g, '_');

    const variantMap = window[mapName];
    if (!variantMap || !variantMap[variantId]) return;

    const variantData = variantMap[variantId];
    const secondaryImage = card.querySelector('[data-card-secondary-image]');

    if (!secondaryImage) return;

    if (!secondaryImage.dataset.originalHoverImage) {
      secondaryImage.dataset.originalHoverImage = secondaryImage.getAttribute('src') || '';
    }

    if (variantData.secondaryImageUrl) {
      secondaryImage.src = variantData.secondaryImageUrl;
      secondaryImage.setAttribute('srcset', variantData.secondaryImageUrl);
    } else if (variantData.imageUrl) {
      secondaryImage.src = variantData.imageUrl;
      secondaryImage.setAttribute('srcset', variantData.imageUrl);
    }
  }

  function resetHoverImage(label) {
    if (!label) return;

    const card = label.closest('[data-card-product]');
    if (!card) return;

    const secondaryImage = card.querySelector('[data-card-secondary-image]');
    if (!secondaryImage) return;

    let checkedInput = card.querySelector('.collection-product-card__swatch input:checked');
    /* Eigenes Collection-Bild: Standardbild behalten, solange keine Variante aktiv gewählt wurde */
    if (card.hasAttribute('data-card-image-override') && !card.dataset.userPicked) checkedInput = null;
    if (checkedInput) {
      updateCardByVariantInput(checkedInput);
      return;
    }

    const originalSecondary = secondaryImage.dataset.defaultSecondaryImage;
    if (originalSecondary) {
      secondaryImage.src = originalSecondary;
      secondaryImage.setAttribute('srcset', originalSecondary);
    }
  }

  function initDefaultVariants(scope) {
    const cards = (scope || document).querySelectorAll('[data-card-product]');

    cards.forEach((card) => {
      if (card.hasAttribute('data-card-image-override')) return;
      const checkedInput = card.querySelector('.collection-product-card__swatch input:checked');
      if (checkedInput) {
        updateCardByVariantInput(checkedInput);
      }
    });
  }

  document.addEventListener('change', function (event) {
    const input = event.target.closest('.collection-product-card__swatch input');
    if (!input) return;

    const pickedCard = input.closest('[data-card-product]');
    if (pickedCard) pickedCard.dataset.userPicked = '1';
    updateCardByVariantInput(input);
  });

  document.addEventListener(
    'mouseenter',
    function (event) {
      const label = event.target.closest('.collection-product-card__swatch label');
      if (!label) return;

      previewHoverImage(label);
    },
    true
  );

  document.addEventListener(
    'mouseleave',
    function (event) {
      const label = event.target.closest('.collection-product-card__swatch label');
      if (!label) return;

      resetHoverImage(label);
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    initDefaultVariants(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initDefaultVariants(event.target);
  });
})();